import React from 'react';
import { AccordionPanel, Box, Divider } from '@chakra-ui/react';
const VerticalAccordionBody = (props) => (React.createElement(AccordionPanel, null,
    React.createElement(Divider, { variant: "grey" }),
    React.createElement(Box, { pt: 4 }, props.children)));
export default VerticalAccordionBody;
